import { PaymentStatus } from "../../../../core/schema/PaymentStatus.js";

export const paymentStatusTextColorMap: Record<PaymentStatus, string> = {
	[PaymentStatus.Unpaid]: "text-primary",
	[PaymentStatus.PaidPartially]: "text-blue",
	[PaymentStatus.Paid]: "text-tertiary",
	[PaymentStatus.Refunded]: "text-blue",
	[PaymentStatus.AwaitingRefund]: "text-blue",
};
